import { CustomizationModalActions, ICustomizationModalState } from "./actions";
import { CustomizationImageFilterDictionary } from "constants/product-customizations/customization";

export interface IReducerAction {
    type: CustomizationModalActions;
    payload?: any;
}

const reducer = (state: ICustomizationModalState, action: IReducerAction) => {
    switch (action.type) {
        case CustomizationModalActions.SetExistingImages:
            return { ...state, existingImages: action.payload };
        case CustomizationModalActions.SetCurrentAttributeId:
            return {
                ...state,
                currentAttributeId: action.payload,
                currentTabCacheKey: getTabCacheKey(action.payload, state.currentMerchantId, state.imageFilters),
            };
        case CustomizationModalActions.SetMerchantId:
            return {
                ...state,
                currentMerchantId: action.payload,
                currentTabCacheKey: getTabCacheKey(state.currentAttributeId, action.payload, state.imageFilters),
            };
        case CustomizationModalActions.ImagesFetchStart:
            return {
                ...state,
                fetchParams: action.payload,
                isFetching: true,
            };
        case CustomizationModalActions.ImagesCheckStart:
            return {
                ...state,
                fetchParams: action.payload,
                isChecking: true,
            };
        case CustomizationModalActions.ImagesFetchEnd:
            return {
                ...state,
                isFetching: false,
            };
        case CustomizationModalActions.ImagesCheckEnd:
            return {
                ...state,
                isFetching: false,
            };
        case CustomizationModalActions.SetImageFilters:
            return {
                ...state,
                imageFilters: action.payload,
                currentTabCacheKey: getTabCacheKey(state.currentAttributeId, state.currentMerchantId, action.payload),
            };
        case CustomizationModalActions.SetProductCustomizationPrintSettings:
            return {
                ...state,
                printSettings: action.payload,
            };
        default:
            throw new Error(`no matching action type : ${action.type}`);
    }
};

const getTabCacheKey = (
    attributeId: string,
    tabType: string | undefined,
    imageFilters: CustomizationImageFilterDictionary | null
): string => {
    const imageFiltersString = imageFilters ? `_${JSON.stringify(imageFilters)}` : "";
    return `${attributeId}_${tabType}${imageFiltersString}`;
};

export default reducer;
